/**
 * SoundWave — a soft, flowing sine wave that gently breathes. Rendered beside
 * the "Wellness" wordmark only while the sound experience is active. It is
 * intentionally not an equalizer and uses no flashy motion.
 */
export const SoundWave = ({ active, color = "#C9A96E" }) => {
  if (!active) return null;
  return (
    <span className="wave-mask inline-flex items-center" data-testid="sound-wave" aria-hidden="true">
      <svg
        className="wave-track"
        width="52"
        height="12"
        viewBox="0 0 52 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 6 Q 3.25 1.5, 6.5 6 T 13 6 T 19.5 6 T 26 6 T 32.5 6 T 39 6 T 45.5 6 T 52 6"
          stroke={color}
          strokeWidth="1.1"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
};

export default SoundWave;
